import React, { ReactNode } from 'react';
import styles from './Paper.module.scss';

export const Paper = (props : {children : ReactNode}) => {
  const { children } = props;
  return (
    <div className={styles.container}>
      {children}
    </div>
  );
};

export default Paper;